export const CHANGE_USER_FULL_NAME = "user::changeFullName";
export const CHANGE_USER_PHOTO = "user::changePhoto";
